export const getFloor = () => {
  const webContext = window.asos.webContext.getWebContext();
  if (!webContext || !webContext?.floor) return "women";
  const floor =
    webContext.floor === "default" || webContext.floor === "women"
      ? "women"
      : "men";

  return floor;
};
